import Vue from 'vue';
import ReferredMerchants from '@/plugins/graphql/queries/v2/network_distributor/referred-merchants.gql';
import { AppAffiliateModel } from '@/helpers/entities/models/AppAffiliateModel';
import moment from 'moment';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
export default Vue.extend({
    apollo: {
        merchants: {
            query: ReferredMerchants,
            variables() {
                return {
                    reseller: this.resellerUuid,
                    planType: this.planType,
                };
            },
            update(data) {
                const merchants = data.adminApps.edges;
                const merchantNodes = (merchant) => {
                    return new AppAffiliateModel(merchant.node);
                };
                return merchants.map(merchantNodes);
            },
        },
    },
    props: {
        resellerUuid: {
            type: String,
            required: true,
        },
        planType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            merchants: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.merchants.length >= 1) {
                return self.merchants.map((merchant) => {
                    return {
                        merchantName: merchant.name,
                        merchantId: merchant.activePage?.fbPageId,
                        planType: self.humanizedPlanType(merchant.subscribedPlanName),
                        activeSalesChannel: merchant.activeSalesChannel.join(','),
                        dateLaunched: merchant.formattedLaunchedAt,
                        storeOwner: merchant.ownerFullName,
                        totalOrders: merchant.accumulatedOrdersCount,
                        accumulatedConvenienceOrder: merchant.accumulatedConvenienceFee,
                    };
                });
            }
            return [];
        },
    },
    methods: {
        formattedLaunchedDate(date) {
            const launchDate = new Date(date);
            return moment(launchDate).format('LLL');
        },
        humanizedPlanType(planType) {
            return enumValueNormalizer(planType);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                merchants: self.dataForCsv,
            });
        }
    },
});
